// stuff
import { Component, NgZone, Input } from '@angular/core';
import { AlertController, LoadingController, NavController } from 'ionic-angular';

// pages
import { AccountNamePage } from '../../pages/account-name/account-name';
import { AccountEmailPage } from '../../pages/account-email/account-email';
import { AccountPasswordPage } from '../../pages/account-password/account-password';

// service provider
import { User } from '../../providers/user';

/**
 * Generated class for the AccountManager component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular 2 Components.
 * 
 * @export
 * @class AccountManagerComponent
 */
@Component({
    selector: 'account-manager',
    templateUrl: 'account-manager.html'
})
export class AccountManagerComponent {

    @Input() profile: any;
    @Input() facebookConnected: boolean = false;
    @Input() googleConnected: boolean = false;

    constructor(
        public zone: NgZone,
        public user: User,
        public loading: LoadingController,
        public nav: NavController,
        public alert: AlertController
    ) {
        this.fetchProfile();
        this.fetchProviders();
    }

    changeName() {
        this.nav.push(AccountNamePage);
    }

    changeEmail() {
        this.nav.push(AccountEmailPage);
    }

    changePassword() {
        this.nav.push(AccountPasswordPage);
    }

    deleteAccount() {
        let loader = this.loading.create({
            content: 'Please wait..',
            duration: 10000
        });

        let confirm = this.alert.create({
            title: 'Delete account?',
            message: 'Sure you want to proceed? this operation can not be undone.',
            buttons: [
                {
                    text: 'Cancelar',
                    handler: () => { }
                },
                {
                    text: 'Ok, understand',
                    handler: () => {
                        loader.present().then(() => {

                            let userId = this.user.profile().uid;
                            // remove database data
                            var userData = this.user.fb.database().ref('users/' + userId);
                            userData.remove().then(() => {
                                // delete user
                                this.user.profile().delete().then(() => {
                                    loader.dismiss().then(() => {
                                        this.showAlert('Success', 'Your account has been deleted.').then(() => {
                                            console.warn('account deleted');
                                        });
                                    });
                                }).catch((e) => {
                                    loader.dismiss().then(() => {
                                        this.errorHandler(e);
                                    });
                                });
                            });
                        });
                    }
                }
            ]
        });
        confirm.present();
    }

    /**
     * Fetch Profile
     * 
     * Attach profile into view
     * 
     * @memberOf AccountManagerComponent
     */
    fetchProfile() {
        let currentUser = this.user.profile();
        this.zone.run(() => {
            this.profile = currentUser;
        });
    }

    /**
     * Fetch Providers
     * 
     * Search for login providers and pass to view
     * 
     * 
     * @memberOf AccountManagerComponent
     */
    fetchProviders() {
        this.user.fb.auth().fetchProvidersForEmail(this.profile.email).then((list) => {
            if (list.length) {
                let facebookConnected = false;
                let googleConnected = false;
                // track facebook
                if (list.find((item) => {
                    return item === 'facebook.com';
                })) {
                    facebookConnected = true;
                }

                // track google
                if (list.find((item) => {
                    return item === 'google.com';
                })) {
                    googleConnected = true;
                }

                this.zone.run(() => {
                    this.facebookConnected = facebookConnected;
                    this.googleConnected = googleConnected;
                });
            }
        }, (error) => {
            console.log(error);
        });
    }

    /**
     * Connect
     * Works only in device
     * 
     * @param {any} provider - current options: facebook, google
     * 
     * @memberOf AccountPage
     */
    connect(provider, event) {
        console.log(event);
        let loader = this.loading.create({
            content: 'Connecting ' + provider,
            duration: 3000
        });
        switch (provider) {
            case 'facebook.com':
                if (!this.facebookConnected) {
                    loader.present().then(() => {
                        this.user.authWithFacebook((token) => {
                            let credential = this.user.fb.auth.FacebookAuthProvider.credential(token);
                            this.profile.link(credential).then((user) => {
                                loader.dismiss().then(() => {
                                    this.zone.run(() => {
                                        this.facebookConnected = true;
                                    });
                                });
                            }, (e) => {
                                console.error(e);
                                loader.dismiss().then(() => {
                                    this.errorHandler(e);
                                });
                            });
                        }, (e) => {
                            console.error(e);
                            loader.dismiss().then(() => {
                                this.errorHandler(e);
                            });
                        });
                    });
                } else if (this.facebookConnected) {
                    this.profile.unlink(provider).then(() => {
                        this.zone.run(() => {
                            this.facebookConnected = false;
                        });
                    }).catch((e) => {
                        console.error(e);
                    });
                }
                break;
            case 'google.com':
                if (!this.googleConnected) {
                    loader.present().then(() => {
                        this.user.authWithGoogle((authData) => {
                            let credential = this.user.fb.auth.GoogleAuthProvider.credential(authData.idToken);
                            this.profile.link(credential).then((user) => {
                                this.zone.run(() => {
                                    this.googleConnected = true;
                                });
                            }, (e) => {
                                console.error(e);
                                this.errorHandler(e);
                            });
                        }, (e) => {
                            console.error(e);
                            loader.dismiss().then(() => {
                                this.errorHandler(e);
                            });
                        });
                    });
                } else if (this.googleConnected) {
                    this.profile.unlink(provider).then(() => {
                        this.zone.run(() => {
                            this.googleConnected = false;
                        });
                    }).catch((e) => {
                        console.error(e);
                    });
                }
                break;
        }
    }

    showAlert(title, subtitle) {
        let alert = this.alert.create({
            title: title,
            subTitle: subtitle,
            buttons: ['OK']
        });
        return alert.present();
    }

    errorHandler(error) {
        let errorCode = error.code;
        let errorMessage = error.message;
        let handler = User.errorHandler(errorCode, errorMessage);
        this.showAlert(handler.title, handler.message);
    }
}


// WEBPACK FOOTER //
// ./src/components/account-manager/account-manager.ts